module.exports = __webpack_public_path__ + "img/blue-ring.83e85b95.png";